import {action} from 'mobx';
import {observer} from 'mobx-react';
import React, {Component} from 'react';

import {withI18n, WithI18nProps} from '@udemy/i18n';
import {FormGroup, Select} from '@udemy/react-form-components';

import {TopicContent} from '../topic-content.react-component';
import {TopicListCollectionStore} from '../topic-list-collection.mobx-store';
import styles from '../topic-list-collection.module.less';

const DEFAULT_PAGE_SIZE = 10;

export interface TopicListCollectionMobileProps extends WithI18nProps {
    store: TopicListCollectionStore;
}

@observer
class _TopicListCollectionMobile extends Component<TopicListCollectionMobileProps> {
    componentDidMount() {
        this.loadTopicStore();
    }

    pageSize: number = DEFAULT_PAGE_SIZE;

    loadTopicStore = () => {
        this.props.store.topicTabs[this.props.store.activeTabId].store.loadTopics(this.pageSize);
    };

    @action
    handleSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
        this.props.store.updateTopicTable(Number(event.target.value));
        this.loadTopicStore();
    };

    render() {
        const topicTabs = this.props.store.topicTabs.map((topicTab, i) => {
            return (
                <option key={i} value={i}>
                    {topicTab.tabName}
                </option>
            );
        });
        const activeTopicContentStore =
            this.props.store.topicTabs[this.props.store.activeTabId].store;
        return (
            <>
                <FormGroup
                    labelProps={{className: 'ud-sr-only'}}
                    label={this.props.gettext('Topic list collection')}
                >
                    <Select
                        defaultValue={this.props.store.activeTabId}
                        onChange={this.handleSelect}
                    >
                        {topicTabs}
                    </Select>
                </FormGroup>
                <div
                    data-testid="mobile-topic-list"
                    className={styles['mobile-topic-content-container']}
                >
                    <TopicContent store={activeTopicContentStore} pageSize={this.pageSize} />
                </div>
            </>
        );
    }
}

export const TopicListCollectionMobile = withI18n(_TopicListCollectionMobile);
